import api, { TIM_LONG_REQUEST_TIMEOUT } from '..';

export type eligibilityPayload = {
  venda_id: number;
};

export const requestEligibility = async (payload: eligibilityPayload) => {
  const { data } = await api
    .post(`/core/elegibilidade`, payload, { timeout: TIM_LONG_REQUEST_TIMEOUT })
    .catch((error) => {
      return Promise.reject(error);
    });

  return data;
};

export const requestEligibilityExpress = async (
  payload: eligibilityPayload,
) => {
  const { data } = await api
    .post(`/core/elegibilidade/express?metodo=pmid`, payload, {
      timeout: TIM_LONG_REQUEST_TIMEOUT,
    })
    .catch((error) => {
      return Promise.reject(error);
    });

  return data;
};
